var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":"Are you sure?","cancel":_vm.cancel,"actions":{'Confirm': _vm.confirm}}},[_vm._v(" Do you really want to delete the "+_vm._s(_vm.itemType)+" "),_c('b',[_vm._v(_vm._s(_vm.itemName))]),_vm._v("? ")])}
var staticRenderFns = []

export { render, staticRenderFns }